import React from 'react';
import { getAskingPrice, mapValueToMoneyFormat } from 'utils';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl } from 'components/ResolveImage/utils';
import { DealRoom } from 'models/DealRoom';
import { Listing } from 'models/Listing';
import { CommonTable } from './data';

export type CellProps = {
  dealRoom?: DealRoom;
  listing?: Listing;
};

export const ListingTitleCell: React.FC<CellProps> = ({
  dealRoom,
  listing,
}) => {
  const { portfolioName } = dealRoom || {};
  const imageSrc = listing.gallery[0]?.url;

  return (
    <div className="pdt-name-cell">
      <ResolveImage src={getImgUrl(imageSrc, '320')} alt="Listing" />
      <span>{portfolioName}</span>
    </div>
  );
};

export const IndustryCellComponent: React.FC<CellProps> = ({ dealRoom }) => {
  const { industry } = dealRoom || {};

  return <div className="pdt-industry-cell">{industry}</div>;
};

export const PriceCellComponent: React.FC<CellProps> = ({ listing }) => {
  const askingPrice = getAskingPrice(listing);

  if (!askingPrice) return null;

  return <div className="pdt-manage-cell">{askingPrice}</div>;
};

export const EbitdaCellComponent: React.FC<CellProps> = ({ listing }) => {
  const { EBITDA } = listing;

  if (!EBITDA) return null;

  return <div className="pdt-ebidta-cell">{mapValueToMoneyFormat(EBITDA)}</div>;
};

export const StateCellComponent: React.FC<CellProps> = ({ dealRoom }) => {
  const { location } = dealRoom;

  if (!location) return null;

  return <div className="pdt-state-cell">{location}</div>;
};

export const COMMON_BODY_CONTENT_GENERATE: Record<
  keyof CommonTable,
  (cellProps: CellProps) => React.ReactNode
> = {
  listing: (cellProps: CellProps) => <ListingTitleCell {...cellProps} />,
  industry: (cellProps: CellProps) => <IndustryCellComponent {...cellProps} />,
  price: (cellProps: CellProps) => <PriceCellComponent {...cellProps} />,
  ebitda: (cellProps: CellProps) => <EbitdaCellComponent {...cellProps} />,
  state: (cellProps: CellProps) => <StateCellComponent {...cellProps} />,
};
